export const numberOfColumnsLabel = "VEd";
export const numberOfRowsLabel = "WEd";
export default {numberOfColumnsLabel,numberOfRowsLabel};